'use client'

import Layout from '@/components/Layout';
import { convertTourDetailImages, TourBookingProvider } from '@/containers/TourBookingByCustomer/providers/TourBookingProvider';
import TourBookingInfoDetail from '@/containers/TourBookingByCustomerHome/TourBookingInfoDetail';
import { TourDetail } from '@/types/tourBooking';
import { GetServerSidePropsContext, InferGetServerSidePropsType } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useRouter } from 'next/router';
import { ReactElement } from 'react';

const SlugTourPage = (
  _props: InferGetServerSidePropsType<typeof getServerSideProps>,
) => {
  const router = useRouter();

  const { slug } = router.query as { slug: string };

  return (
    <TourBookingProvider locale={_props.locale ?? "en"} tourSlug={slug} tourDetailServer={_props.tourDetail}>
      <TourBookingInfoDetail locale={_props.locale ?? "en"} />
    </TourBookingProvider>
  );
};

SlugTourPage.getLayout = (page: ReactElement, _props?: any) => (
  <Layout
    hasBackground={false} // {_props?.query?.tab === TabType.ETAXI}
    hasFooter={_props?.query?.from !== 'hoiango.com'}
    hideHeader={_props?.query?.from === 'hoiango.com'}
    showTabs
    hasPadding={false} //{_props?.query?.tab === TabType.ETAXI}
    backgroundColor="#F1F8FF"
  >
    {page}
  </Layout>
);

SlugTourPage.type = 'public';

export async function getServerSideProps(context: GetServerSidePropsContext) {
  const { locale, query } = context;

  const { tourType, slug } = query;

  const normalizedTourType = typeof tourType === 'string' ? tourType.toLowerCase() : '';
  const hasValidSlug = typeof slug === 'string' && slug.trim().length > 0;
  const validTourTypes = new Set(['adventures', 'experience', 'experiences', 'hoiantours']);

  if (!hasValidSlug) {
    if (normalizedTourType === 'adventures') {
      return {
        redirect: {
          destination: '/adventures',
          permanent: false,
        },
      };
    }

    if (normalizedTourType === 'hoiantours') {
      return {
        redirect: {
          destination: '/hoiantours',
          permanent: false,
        },
      };
    }

    if (normalizedTourType === 'experiences') {
      return {
        redirect: {
          destination: '/experiences',
          permanent: false,
        },
      };
    }
  }

  if (typeof tourType === 'string') {
    if (validTourTypes.has(normalizedTourType)) {
      // Valid exact match, do nothing
    } else {
      return {
        redirect: {
          destination: '/404',
          permanent: false, // false = 302 redirect, true = 308 redirect
        },
      }
    }
  }

  const API_URL = process.env.NEXT_PUBLIC_SERVER_SIDE_BASE_URL ?? process.env.NEXT_PUBLIC_BASE_URL;

  let tourDetail: TourDetail | undefined = undefined;

  try {
    const fetchDetailUrl = `${API_URL}booking_tour/${locale}/tour-slug/${slug}`;
    const res = await fetch(fetchDetailUrl);

    if (!res.ok) {
      throw new Error(`Failed to fetch, status code: ${res.status}`);
    }

    const data = await res.json();

    if (data.tourContents.length == 0) {
      return {
        redirect: {
          destination: '/404',
          permanent: false,
        },
      }
    }

    tourDetail = convertTourDetailImages(data);

  } catch (error) {
    console.error('Error fetching tours:', error);
  }


  return {
    props: {
      ...(await serverSideTranslations(locale ?? 'en', [
        'validate',
        'common',
        'aboutUs',
        'error',
      ])),
      locale,
      query,
      tourDetail,
    },
  };
}

export default SlugTourPage;
